import { render, staticRenderFns } from "./PdfIcon.vue?vue&type=template&id=5f934651&scoped=true&"
import script from "./PdfIcon.vue?vue&type=script&lang=js&"
export * from "./PdfIcon.vue?vue&type=script&lang=js&"
import style0 from "./PdfIcon.vue?vue&type=style&index=0&id=5f934651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f934651",
  null
  
)

component.options.__file = "PdfIcon.vue"
export default component.exports